<template>
  <GradientBarComponent
    :labels="[
      '0.3',
      '0.6',
      '0.9',
      '1.2',
      '1.5',
      '1.8',
      '2.1',
      '2.4',
      '2.7',
      '3.0',
      '3.5',
      '4.0',
      '4.5',
      '5.0',
      '5.5',
      '6.0',
      '7.0',
      '8.0',
      '9.0',
      '10.0',
      '11.0',
      '12.0',
      '13.0',
      '14.0',
      '15.0',
      '16.0',
    ]"
    :gradientColors="[
      '#FF00FF',
      '#D800FF',
      '#B400FF',
      '#8000FF',
      '#2D00FF',
      '#0021FB',
      '#005DFA',
      '#008FFF',
      '#00B7FF',
      '#00D9FF',
      '#00F2FF',
      '#00FDD8',
      '#3CFF5D',
      '#A5FF00',
      '#E6FF00',
      '#FFF200',
      '#FFD900',
      '#FFBD00',
      '#FFA300',
      '#FF8900',
      '#FF6500',
      '#FF2B00',
      '#FF2F2F',
      '#FF6565',
      '#FF8080',
      '#FF8F8F',
    ]"
    unit="m"
  />
</template>
      
      <script>
import GradientBarComponent from "./GradientBarComponent.vue";

export default {
  components: {
    GradientBarComponent,
  },
  data() {
    return {};
  },
};
</script>
    